<div class="signup-container">
  <img
    src="login/corner-logo.png"
    class="logo"
    alt="Sustainment"
  />

  <ng-container *ngIf="!done; else checkEmail">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-header">
        <h2>Create Account</h2>
        <p class="subtitle">Enter your details in order to create an account</p>
      </div>

      <input
        formControlName="firstName"
        placeholder="First name *"
        aria-label="First name"
        autocomplete="given-name"
        capitalizeWords
      />
      <input
        formControlName="lastName"
        placeholder="Last name *"
        aria-label="Last name"
        autocomplete="family-name"
        capitalizeWords
      />
      <input
        formControlName="email"
        type="email"
        placeholder="Email *"
        aria-label="Email"
        autocomplete="email"
      />
      <input
        formControlName="password"
        type="password"
        placeholder="Password *"
        aria-label="Password"
        autocomplete="new-password"
      />

      <p class="required-note">* indicates required field</p>

      <div class="custom-checkbox">
        <input id="input-tos" type="checkbox" formControlName="tos" />
        <label for="input-tos">
          I have read and agree to the
          <a href="https://sustainment.tech/terms-of-use/" target="_blank">Terms of Service</a>
          including the
          <a href="https://sustainment.tech/privacy-policy/" target="_blank">User Agreement and Privacy Policy</a>
        </label>
      </div>

      <p class="error" *ngFor="let error of errors">{{ error }}</p>

      <button type="submit" [disabled]="form.invalid || submitting">
        {{ submitting ? 'Please wait...' : 'Register' }}
      </button>

      <a
        class="back-link"
        routerLink="/login"
        queryParamsHandling="preserve"
        >Back to sign in</a
      >
    </form>
  </ng-container>

  <ng-template #checkEmail>
    <div class="check-email">
      <h2>Check your email</h2>
      <p>
        To finish signing up, check your email.<br />
        If you don't see it in your inbox, check your spam folder.
      </p>
    </div>
  </ng-template>
</div>

<p-confirmDialog
  [key]="'emailValidationConfirm'"
  [closable]="true"
  [baseZIndex]="10000"
  styleClass="dialog-sm"
></p-confirmDialog>
